import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import { NotificationManager } from 'react-notifications'
import SearchFilter from '../../components/Filter/SearchFilter'

const STS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

  const { setHeaderData } = useContext(NavigationContext)

  const [STS, setSTS] = useState([])

  const defaultFilter = {
    name: "STS",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    warehouseId: null,
    warehouseName: "",
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    WarehouseOperationFullName: "DESC",
    IssuedOn: "DESC",
    ToWarehouseOperationFullName: "DESC",
    WarehouseFullName: "ASC",
    Comment: "ASC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getSTS(next);
  };

  useEffect(() => {
      const handleResize = () => {
      setWindowHeight(window.innerHeight)

      const screenHeight = window.innerHeight
      const reservedSpace = 350
      const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

      setFilter(prev => ({
          ...prev,
          rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }))
      }

      window.addEventListener("resize", handleResize)
      handleResize()

      return () => window.removeEventListener("resize", handleResize)
  }, [])

  const search = (f) => {
    getSTS(f || filter)
  }

  const getSTS = (f = filter) => {
    fetchMssqlApi('st-sts', {
      method: 'POST',
      hideNotification: true,
      data: {
        fromCreateDateTime: f.dateTimeRangeFrom,
        toCreateDateTime: f.dateTimeRangeTo,
        machineId: f.machineId,
        warehouseId: f.warehouseId,
        sortBy: f?.sortBy,
      }
    }, response => {
      setSTS(response);
    })
  }

  useEffect(() => {
    getSTS()
    setHeaderData({
      text: TRL_Pack.st.sts
    });
  }, [])

  const getUI = () => {
    if (STS != null) {
      let temp = JSON.parse(JSON.stringify(STS));

      temp.map(STS => {
        delete STS.MachineCoinInventoryId
        delete STS.VisitId
        delete STS.WarehouseOperationId
      })

      return (
        <div>
          <div>
            <SearchFilter
                filterName="STS"
                defaultFilter={defaultFilter}
                onFilterChange={(f) =>
                  setFilter((prev) => ({ ...prev, ...f }))
                }
                onSettingsChange={(s) =>
                  setSettingsFilter((prev) => ({ ...prev, ...s }))
                }
                search={search}
                totalCount={STS.length}
                dataList={STS}
                forNow
            />
            <div className="card">
              <h5 className="card-header">
                <div className='d-flex justify-content-between'>
                    <div></div>
                    <Link to={`/st/0`} className="btn text-nowrap btn-outline-secondary mt-1 mb-1"><i className="fas fa-plus" /></Link>
                </div>
              </h5>
              <div className="overflow-auto custom-scroll"                                     
                style={{
                        maxHeight: `${windowHeight - 214}px`,
                        overflowY: "auto",
                      }}>
                {STS.length ? (
                  <table className="table table-striped">
                    <thead>
                      <tr className="headers-color text-center">
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseOperationFullName")}
                        >
                          Nr <br />Czas zapisu, Źródło{arrow("WarehouseOperationFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("IssuedOn")}
                        >
                          Data / czas wystawienia{arrow("IssuedOn")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("ToWarehouseOperationFullName")}
                        >
                          Dokument powiązany{arrow("ToWarehouseOperationFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseFullName")}
                        >
                          Magazyn{arrow("WarehouseFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("Comment")}
                        >
                          Komentarz{arrow("Comment")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {STS
                        .slice(
                          (filter.page - 1) * rowsPerPage,
                          filter.page * rowsPerPage
                        )
                        .map((entry, idx) => (
                          <tr key={idx}>
                            <td>
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div className="text-nowrap"><Link to={`/st/${entry.WarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-secondary">
                                    ST {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</Link></div>
                                <div className="text-nowrap">{entry.Created}</div>
                              </div>
                            </td>
                            <td>
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div className="text-nowrap">{entry.IssuedOn}</div></div>
                            </td>
                            <td className='text-center'>
                              {entry.ToWarehouseOperationId && <div className="text-nowrap"><Link to={`/wz/${entry.ToWarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-primary">
                                  WZ {entry.ToWarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</Link></div>}
                            </td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>{entry.WarehouseFullName}</div></td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>{entry.Comment}</div></td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <NoResults />
                )
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div>
        {getUI()}
      </div>
    </>
  )
}

export default STS;